/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AssistantMessageSchemaContent } from './assistantMessageSchemaContent';
import type { AssistantMessageSchemaRole } from './assistantMessageSchemaRole';

export interface AssistantMessageSchema {
  role: AssistantMessageSchemaRole;
  content: AssistantMessageSchemaContent;
}
